module.exports = __webpack_public_path__ + "media/images/amenities_icons/free_wine-bc31e10bbbb4c77510e5b67dc47b3da8.svg";